export const messages = {
  name: { id: 'admin/promotions.form.conditions.item-price-range' },
  view: {
    title: {
      id: 'admin/promotions.form.conditions.item-price-range.view.title',
    },
    valueRange: {
      id: 'admin/promotions.form.conditions.item-price-range.view.value-range',
    },
  },
  editor: {
    title: { id: 'admin/promotions.form.conditions.item-price-range' },
    subtitle: {
      id: 'admin/promotions.form.conditions.item-price-range.editor.subtitle',
    },
    min: { id: 'admin/promotions.form.conditions.item-price-range.min' },
    max: { id: 'admin/promotions.form.conditions.item-price-range.max' },
  },

  validation: {
    greaterThan: { id: 'admin/promotions.form.validation.greater-than' },
    maxLowerThanEqualsMin: {
      id: 'admin/promotions.form.validation.max-lower-than-equals-min',
    },
    minGreaterThanEqualsMax: {
      id: 'admin/promotions.form.validation.min-greater-than-equals-max',
    },
  },
}
